import React, { Fragment,Suspense } from 'react'
import ContentLoader from 'react-content-loader'

const RepeatableTableRows = props => {
  const { rows = 5 } = props
  const rowHeight = 50

  return (
    <ContentLoader viewBox={`0 0 1500 ${rowHeight * rows}`} {...props}>
      {new Array(rows).fill(' ').map((el, index) => {
        const contentVerticalPosition = contentHeight =>
          rows > 1 ? contentHeight + rowHeight * index : contentHeight
        return (
          <Fragment key={index}>
            <rect
              x="20"
              y={`${contentVerticalPosition(20)}`}
              rx="4"
              ry="4"
              width="40"
              height="20"
            />
            <rect
              x="100"
              y={`${contentVerticalPosition(20)}`}
              rx="10"
              ry="4"
              width="600"
              height="20"
            />
            <rect
              x="750"
              y={`${contentVerticalPosition(20)}`}
              rx="10"
              ry="4"
              width="600"
              height="20"
            />
            <rect
              x="1450"
              y={`${contentVerticalPosition(20)}`}
              rx="4"
              ry="4"
              width="20"
              height="20"
            />
            <rect
              y={`${contentVerticalPosition(59)}`}
              x="10"
              ry="10"
              width="1500"
              height="1"
            />
          </Fragment>
        )
      })}
    </ContentLoader>
  )
}

const FallbackComponent=()=>{
      return (
        <div style={{width:"100%",height:"90vh",paddingTop:"2rem",overflow:"hidden"}}>
          <RepeatableTableRows rows={18}/>
        </div>
      )
}

const WithTableContentLoader=({children})=>{ 
  return (
    <Suspense fallback={
      <FallbackComponent/>}>
        {children}
    </Suspense>)

}

export default WithTableContentLoader